import React from 'react'
import { Dialog } from 'primereact/dialog';
const ModalMemberExist = ({
    open = false,
    onClose = () => console.log('onClose'),
    onClick = () => console.log('onClick')
}) => {
    return (
        <div>
            <Dialog visible={open} style={{ width: '325px' }} onHide={() => onClose()} draggable={false} resizable={false} closable={false}>
                <div className="bModal bCard" id="ModalMemberNotFound">
                    <div className="bInner">
                        <div className="bDetails">
                            {/* <i className="icoAlert"></i> */}
                            <h3>เบอร์มือถือนี้ได้เป็นสมาชิกกับเราแล้ว</h3>
                            <p>
                                คุณสามารถเข้าสู่ระบบมือถือนี้ได้ <br />ผ่านการยืนยันตัวตัน
                            </p>
                        </div>
                        <div className="bBtn">
                            <a className="btn btnCloseModal" onClick={onClose}>ลองอีกครั้ง</a>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default ModalMemberExist